import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { CompanyPageLayout } from '../components/CompanyPageLayout';
const reviews = [{
  quote: 'Every detail felt considered, but never over-managed. We had room to travel at our own pace.',
  name: 'Maya & James',
  journey: 'Manaslu Circuit · United Kingdom'
}, {
  quote: 'Our guide knew when to explain, when to pause, and when to let the mountain do the talking.',
  name: 'Anika Rao',
  journey: 'Everest View Trek · India'
}, {
  quote: 'From the first call, the advice was honest. The route suited our family beautifully.',
  name: 'Helen Cooper',
  journey: 'Private Nepal Journey · Australia'
}];
export function CustomerReviews() {
  return <CompanyPageLayout eyebrow="Customer reviews" title="What stays with travellers." intro="Stories from guests who came for Nepal’s landscapes and left with a deeper sense of the people, pace, and care behind the journey." data-id="element-435">
      <section className="px-5 py-20 sm:px-8 sm:py-28 lg:px-12" data-id="element-436">
        <div className="mx-auto max-w-[1180px]" data-id="element-437">
          <div className="grid gap-6 md:grid-cols-3" data-id="element-438">
            {reviews.map(review => <article key={review.name} className="flex flex-col border border-[#cfd3c8] bg-[#f4faef] p-7 sm:p-8" data-id="element-439">
                <div className="flex gap-1 text-[#4f8057]" aria-label="Five out of five stars" data-id="element-440">
                  {Array.from({
                length: 5
              }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-441" />)}
                </div>
                <QuoteIcon className="mt-8 h-7 w-7 text-[#6e9b70]" aria-hidden="true" data-id="element-442" />
                <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-[#17362e]" data-id="element-443">
                  “{review.quote}”
                </blockquote>
                <footer className="mt-8 border-t border-[#c7d7c3] pt-5" data-id="element-444">
                  <p className="font-semibold text-[#17362e]" data-id="element-445">{review.name}</p>
                  <p className="mt-1 text-sm text-[#52635a]" data-id="element-446">
                    {review.journey}
                  </p>
                </footer>
              </article>)}
          </div>
        </div>
      </section>
      <section className="bg-[#e7e7db] px-5 py-14 sm:px-8 lg:px-12" data-id="element-447">
        <div className="mx-auto max-w-[1180px]" data-id="element-448">
          <p className="max-w-3xl font-serif text-3xl leading-snug sm:text-4xl" data-id="element-449">
            The most generous reviews describe not only a summit or a view, but
            the calm confidence that made the whole journey possible.
          </p>
        </div>
      </section>
    </CompanyPageLayout>;
}